import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterSolid = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.67911 6.72699V12.5435C9.67911 12.9027 9.55171 13.2489 9.31932 13.5165L7.53435 15.5761C7.07935 16.1011 6.30097 16.1433 5.79558 15.6706C5.53658 15.4292 5.38958 15.0845 5.38958 14.7208V7.95458L0.383265 2.45372C-0.148727 1.86901 -0.123527 0.948324 0.437864 0.397074C0.698259 0.141085 1.04265 0 1.39965 0H12.5505C13.3247 0 13.9504 0.650155 13.9504 1.45449C13.9504 1.82538 13.8146 2.18318 13.5682 2.45372L9.67911 6.72699Z"
	})]
});
const ForwardRef = forwardRef(SvgFilterSolid);
export { ForwardRef as ReactComponent };
